export default __webpack_public_path__ + "static/media/empty.ab82074a.svg";